import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';
import DateTime from 'luxon/src/datetime.js';
import syncTimeToUrl from './plugins/syncTimeToUrl';

Vue.use(Vuex);

const getInitialTimeTravelConfig = () => {
  const params = new URLSearchParams(window.location.search);
  const date = params.get('date');
  const tz = params.get('tz');

  if (!date || isNaN(Number(date)) || !tz) {
    return {
      sinceEpoch: DateTime.utc().toMillis(),
      zone: DateTime.local().zoneName,
    };
  }

  return {
    sinceEpoch: Number(date),
    zone: tz,
  };
};

export default new Vuex.Store({
  state: {
    lights: true,
    sidebar: true,
    path: '',
    time: getInitialTimeTravelConfig(),
    structure: null,
    stuckSettings: [],
    loading: true,
    error: null,
  },

  getters,
  actions,
  mutations,
  plugins: [syncTimeToUrl],
});
